import { ResizeObserver } from "@juggle/resize-observer";
import { mapObjIndexed } from "ramda";
import { useCallback, useMemo, useState } from "react";

export function useRects() {
  const nodes: { [key: string]: HTMLDivElement } = useMemo(() => ({}), []);

  const setRef = useCallback(
    (node: HTMLDivElement | null, id: string) => {
      if (!!node) {
        nodes[id] = node;
      }
    },
    [nodes]
  );

  return [setRef, nodes] as const;
}
